import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import useTranslator from "../../../hooks/useTranslator";
import KgGreen from "../../../images/kg_green.svg";
import Box from "../../../images/boxes.svg";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const ReworkRefrigeration = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const listItems = [
    {
      label: _t("rework_refrigeration_total_kg", "Total KG in Refrigeration"),
      value: 0,
      icon: KgGreen,
    },
    {
      label: _t("rework_refrigeration_total_cases", "Total Cases in Refrigeration"),
      value: 0,
      icon: Box,
    },
  ];

  const columns = [
    {
      label: _t("date", "Date"),
      accessor: "date",
    },
    {
      label: _t("lot_number", "Lot Number"),
      accessor: "lot_number",
    },
    {
      label: _t("total_kg", "Total KG"),
      accessor: "total_kg",
    },
    {
      label: _t("total_cases", "Total Cases"),
      accessor: "total_cases",
    },
    {
      label: _t("temperature", "Temperature"),
      accessor: "temperature",
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
    },
  ];

  return (
    <div>
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("rework_refrigeration_overview_title", "Rework Refrigeration Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("common_today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <Datatable
        title={_t("rework_refrigeration_logs_title", "Rework Refrigeration Logs")}
        columns={columns}
        tableData={[]}
        onPageChange={handlePageChange}
        page={page}
        showCount={true}
        showPegination={true}
        isLoading={false}
      />
    </div>
  );
};

export default ReworkRefrigeration;
